// Redux Actions
// More info about explanation of Redux Actions; https://redux.js.org/basics/actions

// Home actions
export const FETCH_HOME = 'FETCH_HOME';
export const FETCH_HOME_FAILED = 'FETCH_HOME_FAILED';
export const FETCH_HOME_START = 'FETCH_HOME_START';

// Posts actions
export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_POSTS_START = 'FETCH_POSTS_START';
export const FETCH_POST = 'FETCH_POST';

// Work actions
export const FETCH_WORK = 'FETCH_WORK';
export const FAILED_WORK = 'FAILED_WORK';

// Menu action
export const FETCH_MAIN_MENU = 'FETCH_MAIN_MENU';

// InstaFeed actions
// export const FAILED_INSTAWP = 'FAILED_INSTAWP';
// export const FETCH_INSTAWP = 'FETCH_INSTAWP';
// export const FETCH_INSTAWP_START = 'FETCH_INSTAWP_START';

// BTSFeed actions
export const FAILED_BTSWP = 'FAILED_BTSWP';
export const FETCH_BTSWP = 'FETCH_BTSWP';
export const FETCH_BTSWP_START = 'FETCH_BTSWP_START';

export const FETCH_MORE = 'FETCH_MORE';
export const FETCH_MORE_START = 'FETCH_MORE_START';

// Optionfield actions
export const SET_OPTIONS_START = 'SET_OPTIONS_START';
export const SET_OPTIONS = 'SET_OPTIONS';

// Post images
export const SET_IMAGE_START = 'SET_IMAGE_START';
export const SET_IMAGES = 'SET_IMAGES';



// WEBPACK FOOTER //
// ./src/actions/index.jsx